import { PageModel, SurveyModel } from "survey-core";
import { Steps } from "antd";
import { createStyles } from "antd-style";

const useStyles = createStyles(({ css }) => ({
  topBar: css`
    padding: 16px 24px;

    .ant-steps-item-title {
      display: none !important;
    }
  `,
}));

interface TopBarProps {
  survey: SurveyModel;
}

export const TopBar = ({ survey }: TopBarProps) => {
  const { styles } = useStyles();

  const pages = survey.pages.filter(
    (page: PageModel) => !page.isStartPage && page.title,
  );
  const activePageIndex = pages.findIndex(
    (page: PageModel) => page.name === survey.activePage?.name,
  );

  const items = [
    ...pages.map(() => ({ title: "" })),
    ...(survey.completedPageAsStep ? [{ title: "" }] : []),
  ];

  return (
    <div className={styles.topBar}>
      <Steps
        progressDot
        responsive={false}
        current={activePageIndex < 0 ? 0 : activePageIndex}
        items={items}
      />
    </div>
  );
};
